// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'
import utils from './common/utils'
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css'
import Vant from 'vant'
Vue.use(Vant)
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css';
Vue.use(MintUI)
// import VConsole from 'vconsole/dist/vconsole.min.js'
Vue.prototype.utils = utils

Vue.config.productionTip = false

// const vConsole = new VConsole()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js